package app.nestbridge.feature.children.usecase

import app.nestbridge.feature.children.model.Child
import app.nestbridge.feature.children.service.ChildService
import me.tatarka.inject.annotations.Inject

@Inject
class SaveChildUseCase(
    private val childService: ChildService,
) {
    suspend operator fun invoke(child: Child): Child = childService.save(child)
}
